import React from 'react';
import Select from '../Select/Select';
import { RESIDENT_TYPES } from '../../constants';

const SelectResitentType = ({ ...props }) => {
  return <Select options={RESIDENT_TYPES} label={'Признак резиденства'} placeholder={'Выберите из списка'} {...props} />;
};

export default SelectResitentType;
